"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDropdownIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DropdownIconMixin = require("../../mixins/components/DropdownIconMixin");
var StyledDropdownIcon = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "StyledDropdownIcon",
  componentId: "c11n-8-107-0__sc-rynrb-0"
})(["", ""], _DropdownIconMixin.DropdownIconMixin);
exports.StyledDropdownIcon = StyledDropdownIcon;